import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/auth";

const RequiredAuth = () => {
    const { accessToken } = useAuth();
    const location = useLocation();
    return accessToken ? (
        <Outlet />
    ) : (
        <Navigate to="/redirect_login/" state={{ from: location }} replace />
    );
};

export default RequiredAuth;
